import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface AddArticlesState {
  isOpen: boolean;
}

const initialState: AddArticlesState = {
  isOpen: false,
};

const addArticlesSlice = createSlice({
  name: 'addArticles',
  initialState,
  reducers: {
    openAddArticles: (state) => {
      state.isOpen = true;
    },
    closeAddArticles: (state) => {
      state.isOpen = false;
    },
    setAddArticlesOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
  },
});

export const { openAddArticles, closeAddArticles, setAddArticlesOpen } = addArticlesSlice.actions;
export default addArticlesSlice.reducer;